
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";

  import DropdownOption from "@/entities/DropdownOption";
  import DropdownGroupOption from "@/entities/DropdownGroupOption";
  import States from "@/entities/locationEntities/States";
  import Provinces from "@/entities/locationEntities/Provinces";
  import onlyPrimaryCountries from "@/helpers/locations/onlyPrimaryCountries";
  import getCountryRelatedValue from "@/helpers/locations/getCountryRelatedValue";

  @Component({
    components: {
      DropdownFilter,
    },
  })
  export default class StateProvinceSelect extends Vue {
    @Prop({ type: Array, default: () => [] }) value!: DropdownOption[];
    @Prop({ type: Boolean, default: false }) searchable!: boolean;
    @Prop({ type: Boolean, default: false }) multiple!: boolean;
    @Prop({ type: Boolean, default: false }) disabled!: boolean;
    @Prop({ type: Array, default: () => [] }) countries!: DropdownOption[];
     @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;

    stateSearchString = "";
    states: DropdownOption[] = (Object.keys(States) as Array<keyof typeof States>).map(key => {
      return {
        id: States[key],
        name: States[key],
      }
    });

    provinces: DropdownOption[] = (Object.keys(Provinces) as Array<keyof typeof Provinces>).map(key => {
      return {
        id: Provinces[key],
        name: Provinces[key],
      }
    });

    get labelsShown(): boolean {
      return this.multiple && onlyPrimaryCountries(this.countries);
    }

    get groupLabelName(): string {
      return this.labelsShown ? "label" : "";
    }

    get groupValuesName(): string {
      return this.labelsShown ? "values" : "";
    }

    get options(): DropdownOption[] | DropdownGroupOption[] {
      return this.multiple ? this.optionsForMultipleChoices : this.optionsForSingleChoice;
    }

    get optionsForSingleChoice(): DropdownOption[] {
      return getCountryRelatedValue<DropdownOption[]>({
        countries: this.countries,
        primary: [],
        onlyUSA: this.filterMatchingOptions(this.states, this.stateSearchString),
        onlyCanada: this.filterMatchingOptions(this.provinces, this.stateSearchString),
        defaultValue: [],
      });
    }

    get optionsForMultipleChoices(): DropdownOption[] | DropdownGroupOption[] {
      return getCountryRelatedValue<DropdownOption[] | DropdownGroupOption[]>({
        countries: this.countries,
        primary: this.onlyPrimaryRegionsList,
        onlyUSA: this.filterMatchingOptions(this.states, this.stateSearchString),
        onlyCanada: this.filterMatchingOptions(this.provinces, this.stateSearchString),
        defaultValue: [],
      });
    }

    get onlyPrimaryRegionsList(): DropdownGroupOption[] {
      const provincesAndStates = [
        { label: "USA",
          values: this.states,
        },
        {
          label: "Canada",
          values: this.provinces
        }
      ];

      if (!this.stateSearchString) {
        return provincesAndStates;
      }

      const filteredOptions = [
        {
          label: "Canada",
          values: this.filterMatchingOptions(this.provinces, this.stateSearchString)
        },
        { label: "USA",
          values: this.filterMatchingOptions(this.states, this.stateSearchString)
        },
      ]

      if (!filteredOptions.flatMap(option => option.values).length) {
        return [];
      }
      return filteredOptions;
    }

    filterMatchingOptions(options: DropdownOption[], searchString: string) {
      return options.filter(option => this.hasSearchValue(option.name, searchString));
    }

    hasSearchValue(optionName: string, searchString: string) {
      return optionName.toLowerCase().includes(searchString.toLowerCase());
    }

    handleSearch(val: string) {
      this.stateSearchString = val;
    }

    handleInput(val: DropdownOption[]): void {
      this.$emit("input", val);
    }
  }
